<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="btn" :loading="isLoading" v-bind="attrs" v-on="on" color="info">
        {{ $t("components.thg.ThgQuoteVehicleUpdateRegistrationDialog.dialogBtnText") }}
      </v-btn>
      <v-btn v-else :loading="isLoading" v-bind="attrs" v-on="on" icon>
        <v-icon color="grey lighten-1">mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span>
          {{ $t("components.thg.ThgQuoteVehicleUpdateRegistrationDialog.dialogTitle") }}
        </span>
        <v-spacer />
        <v-btn icon>
          <v-icon @click="close" color="grey lighten-1">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-html="$t('components.thg.ThgQuoteVehicleUpdateRegistrationDialog.dialogText')" />
      <v-card-text>
        <thg-quote-workitem-registration-card
          @submit="submit"
          :isResetValidation="true"
          :selectedThg="myThg"
          :selectedUser="user"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import ThgQuoteWorkitemRegistrationCard from "@/components/thg/ThgQuoteWorkitemRegistrationCard.vue";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ThgRegistrationDtoGen } from "@/services/thg/v1/data-contracts";
import { IThg } from "@/models/thg.entity";

import { ThgModule } from "@/store/modules/thg.store";
import { UserModule } from "@/store/modules/me-user.store";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    ThgQuoteWorkitemRegistrationCard
  }
})
export default class ThgQuoteVehicleUpdateRegistrationDialog extends DarkModeHighlightMixin {
  @Prop()
  selectedThg!: IThg;

  @Prop({ default: true })
  btn!: boolean;

  get myThg() {
    return this.selectedThg;
  }

  isLoading = false;

  dialog = false;

  async submit(registrationDto: ThgRegistrationDtoGen) {
    this.dialog = false;
    this.isLoading = true;
    await ThgModule.addRegistrationToMyThg({ thdId: this.selectedThg.id, registrationDto });
    this.isLoading = false;
  }

  get loading() {
    return this.isLoading;
  }

  get user() {
    return UserModule.user;
  }

  close() {
    this.dialog = false;
  }
}
</script>
